import { createContext, ReactNode, useContext, useState } from 'react';

export interface FormContextType {
  trigger: boolean;
  setTrigger: (args0: boolean) => void;
  pk: string;
  setPk: (args0: string) => void;
  sk: string;
  setSk: (args0: string) => void;
  accessToken: string;
  setAccessToken: (args0: string) => void;
  formType: string;
  setFormType: (args0: string) => void;
  title: string;
  setTitle: (args0: string) => void;
  message: string;
  setMessage: (args0: string) => void;
  image: string;
  setImage: (args0: string) => void;
  timestamp: string;
  setTimestamp: (args0: string) => void;
}

// Context provider component
interface FormContextProviderProps {
  children: ReactNode;
}

const FormContext = createContext<FormContextType | undefined>(undefined);

export const FormContextProvider = ({
  children,
}: FormContextProviderProps): JSX.Element => {
  const [trigger, setTrigger] = useState<boolean>(false);
  const [pk, setPk] = useState<string>('');
  const [sk, setSk] = useState<string>('');
  const [accessToken, setAccessToken] = useState<string>('');
  const [formType, setFormType] = useState<string>('');
  const [title, setTitle] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [image, setImage] = useState<string>('');
  const [timestamp, setTimestamp] = useState<string>('');

  return (
    <FormContext.Provider
      value={{
        trigger,
        setTrigger,
        pk,
        setPk,
        sk,
        setSk,
        accessToken,
        setAccessToken,
        formType,
        setFormType,
        title,
        setTitle,
        message,
        setMessage,
        image,
        setImage,
        timestamp,
        setTimestamp,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export const useFormContext = (): FormContextType => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error('useFormContext must be used within a FormContextProvider');
  }
  return context;
};
